var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.body != null)?_c('div',{staticClass:"page"},[_c('section',{staticClass:"text_center"},[_c('h2',{staticClass:"header_underline"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"page_body text_left",domProps:{"innerHTML":_vm._s(_vm.body)}})])]):(_vm.isNotFound)?_c('div',[_c('NotFound')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }